import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'containers.EmbeddedDealPage.components.RatesCalculator.title',
    defaultMessage: 'Non-broadcast rates calculator',
  },
  warning: {
    id: 'containers.EmbeddedDealPage.components.RatesCalculator.warning',
    defaultMessage: 'Please note that the non-broadcast rates calculator is only for test purposes and should not be used for actual financial decisions.',
  },
  supplier: {
    id: 'containers.EmbeddedDealPage.components.RatesCalculator.supplier',
    defaultMessage: 'Supplier',
  },
  product: {
    id: 'containers.EmbeddedDealPage.components.RatesCalculator.product',
    defaultMessage: 'Product',
  },
  wordCount: {
    id: 'containers.EmbeddedDealPage.components.RatesCalculator.wordCount',
    defaultMessage: 'Word count',
  },
  cost: {
    id: 'containers.EmbeddedDealPage.components.RatesCalculator.cost',
    defaultMessage: 'Suggested cost',
  },
  price: {
    id: 'containers.EmbeddedDealPage.components.RatesCalculator.Price',
    defaultMessage: 'Suggested price',
  },
  calculate: {
    id: 'containers.EmbeddedDealPage.components.RatesCalculator.calculate',
    defaultMessage: 'Calculate',
  },
  loading: {
    id: 'containers.EmbeddedDealPage.components.RatesCalculator.loading',
    defaultMessage: 'Calculating',
  }
})
